/**
 * Wohin sich eine Schule mit Änderungswünschen wendet.
 *
 * An genau einer Stelle, weil die Adresse in mehreren Sätzen vorkommt und eine
 * zweite Fassung irgendwann veraltet.
 *
 * ANPASSEN vor dem ersten Verkauf: die Adresse muss tatsächlich gelesen werden.
 * Steht hier eine, die niemand abruft, ist der Hinweis schlechter als keiner -
 * dann schreibt eine Schulleitung ins Leere und hält uns für nicht erreichbar.
 */
export const SUPPORT_EMAIL = "kontakt@otto-tippt-los.de";
